import classNames from "classnames";
import React, { useState } from "react";
import { useOrderDetails } from "../../contexts/orderDetails";
import { FaEdit } from "react-icons/fa";
import OrderStatusForm from "./OrderStatusForm";
import { format } from "date-fns";
import FormForReadyRoll from "./FormForReadyRoll";
import { useAuth } from "../../contexts/auth";

const CheckBox = ({ isChecked = false }) => {
  return (
    <div
      className={classNames(
        "absolute w-8 h-8 border-2  top-0 left-0 -translate-x-1/2 ",
        isChecked ? "bg-navy-blue border-navy-blue" : "border-gray-200 bg-white"
      )}
    >
      <span className="block w-6 h-3 border-l-4 border-b-4 border-white -rotate-45 relative top-1.5 left-1"></span>
    </div>
  );
};

const StatusCard = ({
  statusType,
  isOrderStarted,
  message,
  date,
  notes,
  isReadyToStart,
  isReadyToEdit,
  setOrderStateData,
  setIsReadyRollFormOpen,
}) => {
  const [{ orderDetails }] = useOrderDetails();
  const [{ isEditor }] = useAuth();
  return (
    <div
      className={classNames(
        "border-l-[3px] min-h-[100px] pb-5",
        isOrderStarted ? "border-navy-blue" : "border-gray-300 border-dashed"
      )}
    >
      <div className="flex relative justify-between pl-10">
        <CheckBox isChecked={isOrderStarted} />
        <p className="capitalize">{statusType}</p>
        {isEditor && (
          <>
            {isReadyToStart ? (
              <button
                onClick={() => {
                  setOrderStateData({ type: statusType, isEditMode: false });
                }}
                className="bg-navy-blue text-white p-1 rounded-md capitalize px-1"
              >
                start {statusType}
              </button>
            ) : isReadyToEdit && statusType !== "packing" ? (
              <button
                className="bg-navy-blue text-white p-1 rounded-md capitalize px-1"
                onClick={() => {
                  setOrderStateData({ type: statusType, isEditMode: true });
                }}
              >
                <FaEdit />
              </button>
            ) : null}
            {isReadyToEdit &&
              statusType === "packing" &&
              orderDetails?.roll - orderDetails?.ready_roll > 0 && (
                <button
                  className="bg-navy-blue text-white p-1 rounded-md capitalize px-2"
                  onClick={() => {
                    setIsReadyRollFormOpen(true);
                  }}
                >
                  Ready Roll
                </button>
              )}
          </>
        )}
      </div>
      <div className="pl-10">
        {!isOrderStarted && <p className="text-navy-blue italic">{message}</p>}
        <p className="text-navy-blue">
          {date ? format(new Date(date), "dd-LLL-yyyy hh-mm a") : ""}
        </p>
        <div className="flex justify-between">
          <p className="text-gray-500">{notes}</p>
          {isReadyToEdit && isEditor && statusType === "packing" && (
            <button
              className="bg-navy-blue text-white p-1 rounded-md capitalize px-1"
              onClick={() => {
                setOrderStateData({ type: statusType, isEditMode: true });
              }}
            >
              <FaEdit />
            </button>
          )}
        </div>

        {orderDetails.partially_dispatch > 0 && statusType == "packing" && (
          <div>
            <p className="text-navy-blue italic">{`${orderDetails?.ready_roll}/${orderDetails?.roll} Ready`}</p>

            <div className="text-gray-500 italic">
              <p>
                Partially order dispatch total {orderDetails.partially_dispatch}{" "}
                rolls
              </p>

              {orderDetails.dispatch_records?.map(
                ({ id, no_of_rolls, created_at }) => {
                  return (
                    <div key={id}>
                      Partially Dispatch {no_of_rolls} rolls at{" "}
                      {format(new Date(created_at), "dd-LLL-yyyy hh-mm a")}
                    </div>
                  );
                }
              )}
              <p></p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default function SectionOrderTimeline() {
  const [{ activeUser, isEditor }] = useAuth();
  const [{ orderDetails }] = useOrderDetails();
  const [orderStateData, setOrderStateData] = useState();
  const [isReadyRollFormOpen, setIsReadyRollFormOpen] = useState(false);
  const [isPartialDispatchFormOpen, setIsPartialDispatchFormOpen] =
    useState(false);

  return (
    <div className="col-span-4 border border-gray-400 rounded-md">
      <OrderStatusForm
        orderStateData={orderStateData}
        setOrderStateData={setOrderStateData}
      />
      <FormForReadyRoll
        isReadyRollFormOpen={isReadyRollFormOpen}
        setIsReadyRollFormOpen={setIsReadyRollFormOpen}
        isPartialDispatchFormOpen={isPartialDispatchFormOpen}
        setIsPartialDispatchFormOpen={setIsPartialDispatchFormOpen}
      />
      <div className="pl-10 pt-6 pr-6">
        {/* punching */}
        <StatusCard
          statusType="punching"
          isOrderStarted={orderDetails?.status?.punching == 1}
          message="Waiting for Punching"
          date={orderDetails?.status?.punching_date}
          notes={orderDetails?.status?.punching_note}
          isReadyToStart={orderDetails.order_status == 1}
          isReadyToEdit={orderDetails.order_status > 1}
          setOrderStateData={setOrderStateData}
        />

        {/* slitting */}
        <StatusCard
          statusType="slitting"
          isOrderStarted={orderDetails?.status?.slitting == 1}
          message="Not Started Yet"
          date={orderDetails?.status?.slitting_date}
          notes={orderDetails?.status?.slitting_note}
          isReadyToStart={orderDetails.order_status == 2}
          isReadyToEdit={orderDetails.order_status > 2}
          setOrderStateData={setOrderStateData}
        />

        {/* packing */}
        <StatusCard
          statusType="packing"
          isOrderStarted={orderDetails?.status?.packing == 1}
          message="Not Started Yet"
          date={orderDetails?.status?.packing_date}
          notes={orderDetails?.status?.packing_note}
          isReadyToStart={
            orderDetails.order_status == 3 && orderDetails?.status?.packing == 0
          }
          isReadyToEdit={
            orderDetails.order_status > 2 && orderDetails?.status?.packing == 1
          }
          setOrderStateData={setOrderStateData}
          setIsReadyRollFormOpen={setIsReadyRollFormOpen}
        />

        <div className="min-h-[100px]">
          <div className="flex relative justify-between pl-10">
            <CheckBox isChecked={orderDetails?.status?.dispatch} />
            <p className="capitalize">dispatch</p>
            {!!(
              isEditor &&
              orderDetails.order_status > 2 &&
              orderDetails.ready_roll - orderDetails.partially_dispatch > 0
            ) && (
              <div>
                {orderDetails?.roll - orderDetails?.ready_roll == 0 ? (
                  <button
                    onClick={() => {
                      setOrderStateData({
                        type: "dispatch",
                        isEditMode: false,
                      });
                    }}
                    className="bg-navy-blue text-white p-1 rounded-md capitalize px-2"
                  >
                    Dispatch Now
                  </button>
                ) : (
                  <button
                    className="bg-navy-blue text-white p-1 rounded-md capitalize px-2"
                    onClick={() => {
                      setIsPartialDispatchFormOpen(true);
                    }}
                  >
                    Partially Dispatch
                  </button>
                )}
              </div>
            )}
          </div>
          <div className="pl-10">
            {!orderDetails?.status?.dispatch && (
              <p className="text-navy-blue">
                Deadline{" "}
                {orderDetails?.due_date
                  ? format(new Date(orderDetails?.due_date), "dd-LLL-yyyy")
                  : "---"}
              </p>
            )}

            {!!orderDetails?.status?.dispatch && (
              <p className="text-navy-blue">
                {orderDetails?.status?.dispatch_date
                  ? format(
                      new Date(orderDetails?.status?.dispatch_date),
                      "dd-LLL-yyyy hh-mm b"
                    )
                  : "--"}
              </p>
            )}

            <div className="flex justify-between">
              <p className="text-gray-500">
                {orderDetails?.status?.dispatch_note}
              </p>
              {orderDetails.order_status > 3 && isEditor && (
                <button
                  className="bg-navy-blue text-white p-1 rounded-md capitalize "
                  onClick={() => {
                    setOrderStateData({ type: "dispatch", isEditMode: true });
                  }}
                >
                  <FaEdit />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
